export default function validateAnswer(input, answer) {
  if (input.toLowerCase() === answer.toLowerCase()) return true;
  else return false;
}
